<template>
  <button :class="['relative', btnClass]" disabled>
    <span class='spinner-outer'><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></span>
    <span style='opacity: 0'>{{ btnLabel }}</span>
  </button>
</template>

<script>
export default {
  name: 'ButtonLoading',
  props: ['btnClass','btnLabel'],
}
</script>

<style lang='scss' scoped>
//@import "~/assets/scss/src/_spinner.scss";
button {
  pointer-events: none;
}
</style>
